import { db } from '../storage/db.js';
import { snapshot } from './log-buffer.js';
import { enqueueLog } from '../telemetry/log-batcher.js';

/**
 * Diagnostic overlay kurtarma aksiyonları.
 */

/** Mevcut log buffer'ını device_logs'a gönder (log-batcher kuyruğu üzerinden). */
export function sendSnapshot(): number {
    const entries = snapshot();
    for (const e of entries) {
        enqueueLog({
            ts: e.ts,
            level: e.level === 'debug' ? 'info' : e.level,
            message: e.message,
            context: { source: 'diagnostic_snapshot' },
        });
    }
    return entries.length;
}

/** Dexie + SW cache + caches storage temizle, sayfayı yeniden yükle. */
export async function clearCacheAndReload(): Promise<void> {
    try {
        await Promise.all([
            db.layout.clear(),
            db.theme.clear(),
            db.last_ticks.clear(),
            db.meta.clear(),
        ]);
    } catch (e) {
        console.warn('[diagnostic] dexie clear hata', e);
    }

    if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
    }
    if ('caches' in window) {
        const names = await caches.keys();
        await Promise.all(names.map((n) => caches.delete(n)));
    }

    window.location.reload();
}

/** Eşleştirmeyi sıfırla — token + gateway url + PIN + cache sil, pairing sayfasına dön. */
export async function resetPairing(): Promise<void> {
    try {
        localStorage.removeItem('fp.device.token');
        localStorage.removeItem('fp.gateway.url'); // eski gateway'e yanlış bağlanmayı önle (L8)
        localStorage.removeItem('fp.diagnostic.pin'); // yeni eşleme yeni PIN yazar (K4)
        await Promise.all([
            db.layout.clear(),
            db.theme.clear(),
            db.last_ticks.clear(),
            db.meta.clear(),
        ]);
    } catch (e) {
        console.warn('[diagnostic] reset pairing hata', e);
    }
    window.location.href = '/pair';
}
